import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgUserIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.6 6.4a3.2 3.2 0 0 1 3.2-3.2h6.4a3.2 3.2 0 0 1 3.2 3.2v8a3.2 3.2 0 0 1-3.2 3.2h-6.4a3.2 3.2 0 0 1-3.2-3.2zm9.6 0h-6.4v8h6.4zM16 28.8a6.4 6.4 0 0 1 6.4-6.4h19.2a6.4 6.4 0 0 1 6.4 6.4v12a3.2 3.2 0 0 1-1.28 2.56L41.6 47.2v10.4a3.2 3.2 0 0 1-3.2 3.2H25.6a3.2 3.2 0 0 1-3.2-3.2V47.2l-5.12-3.84A3.2 3.2 0 0 1 16 40.8zm6.4 14.4V32h3.2v25.6h12.8V32h3.2v11.2l3.2-2.4v-12a3.2 3.2 0 0 0-3.2-3.2H22.4a3.2 3.2 0 0 0-3.2 3.2v12z"
    />
  </svg>
)
export default SvgUserIcon
